import { Button, Heading, TableAccordion } from "arag-ui-lib"
import { useState } from "react"
import { amountColumnsDisplayDataPerStage } from "../../helpers/functions";
import StagedStep4 from "./WizardSteps/stagedStep4";

const StagedPremiumSettingsCombinationTable = (props) => {
  const [featuredItems, setFeaturedItems] = useState([]);

  const onItemSelect = (itemId) => {
    let newItems = [...featuredItems];
    if (featuredItems.includes(itemId)) {
      newItems = newItems.filter(item => item !== itemId);
    } else {
      newItems = [...newItems, itemId]
    }
    setFeaturedItems(newItems);
  };
  return (
    <div>

      <ul id="sortable" className="unorderedListNoBulletsAndSpace">
        {
          props.allStagedPremiums.map((item, index) => {
            return (
              <li key={index} className="refSettingsListItem">
                <a
                  onClick={() => onItemSelect(item.id)}
                  className={`refToggle`}
                >
                  {new Date(item.validFrom).toLocaleDateString("en-GB") + (item.validUntil ? (' - ' + new Date(item.validUntil).toLocaleDateString("en-GB")) : '')}
                </a>
                <div className={`refInner ${featuredItems.includes(item.id) ? 'show' : ''}`} style={{ paddingTop: 20 }}>
                  <Button variant="quaternary" arrowDirection="right"
                    onClick={() => {
                      props.push('premium-settings/edit-staged-premium-settings/' + item.id)
                    }}
                    btnStyle={'btn btn-primary btn-xs sharp white'}
                    label="Edit" />
                  <form className="form-horizontal">
                    <StagedStep4
                      amountColumnsDisplayDataPerStage={amountColumnsDisplayDataPerStage}
           				    isApplicationPremium={false}
                      stagedPremiumData={item}
                      stagesSubSettings={item.stagedPremiumSubSettings}
                    />
                  </form>
                </div>
              </li>
            )
          })
        }
      </ul>


    </div>
  )
}
export default StagedPremiumSettingsCombinationTable;